import styled, { css } from 'styled-components';
import BgProfile from 'assets/img/common/bg_profile.svg';
import { TSize } from '.';

interface ImageWrapperProps {
    background?: string;
    size?: TSize;
}

export const ProfileImage = styled.div<ImageWrapperProps>`

${props => {
        if (props.size === 'XS') {
            return css`
        width: 32px;
        height: 32px;
        border-radius: 9px;
        `;
        } else if (props.size === 'S') {
            return css`
        width: 44px;
        height: 44px;
        border-radius: 13px;
        `;
        } else if (props.size === 'L') {
            return css`
        width: 72px;
        height: 72px;
        border-radius: 21px;
        `;
        } else if (props.size === 'XL') {
            return css`
        width: 104px;
        height: 104px;
        border-radius: 29px;
        `;
        } else {
            return css`
        width: 56px;
        height: 56px;
        border-radius: 17px;
        `;
        }
    }}
    background-image: url('${props => props.background ? props.background : BgProfile}');
    background-size: cover;
    background-position: center;
    position: relative;

    > svg {
        position: absolute;
        right: 0;
        bottom: 0;
    }
`;